import { VFC } from 'react';
import { NotFoundContent } from 'routes/not_found/components/NotFoundContent';
import { OldValuesStepContent } from './steps/old_values/Content';
import { NewValuesStepContent } from './steps/new_values/Content';
import { ReviewStepContent } from './steps/review/Content';
import { DetailsStepContent } from './steps/details/Content';
import { ReplaceMeterStep } from './enums/replaceMeterSteps';

const MAP = {
  [ReplaceMeterStep.OldValues]: OldValuesStepContent,
  [ReplaceMeterStep.NewValues]: NewValuesStepContent,
  [ReplaceMeterStep.Details]: DetailsStepContent,
  [ReplaceMeterStep.Review]: ReviewStepContent,
} satisfies Record<ReplaceMeterStep, VFC>;

export const getContentByStep = (newStep: ReplaceMeterStep): VFC => MAP[newStep] ?? NotFoundContent;
